export const KeepOriginalHeadersKey = 'keep-original';
export const NoAuthorizationHeaderKey = 'no-authorization';
